import { render, staticRenderFns } from "./form-row-documents.vue?vue&type=template&id=416ccf26&scoped=true&"
import script from "./form-row-documents.vue?vue&type=script&lang=js&"
export * from "./form-row-documents.vue?vue&type=script&lang=js&"
import style0 from "./form-row-documents.vue?vue&type=style&index=0&id=416ccf26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416ccf26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('416ccf26')) {
      api.createRecord('416ccf26', component.options)
    } else {
      api.reload('416ccf26', component.options)
    }
    module.hot.accept("./form-row-documents.vue?vue&type=template&id=416ccf26&scoped=true&", function () {
      api.rerender('416ccf26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/form-row-documents.vue"
export default component.exports